<template>
  <v-container>
    <v-card>
      <v-card-title>Problems</v-card-title>
      <v-card-text>
        <v-row
              class="pt-2"
            >
              <v-col
                v-for="(problem, i) in problems"
                :key="`problem-${i}`"
                cols="12"
                md="4"
                lg="3"
              >
                <v-card
                  elevation="2"
                >
                  <v-card-title>
                    <v-sheet
                      color="accent"
                      width="100%"
                      class="overflow-hidden mt-n6 transition-swing"
                      elevation="3"
                      max-width="100%"
                      rounded
                    >
                      <v-theme-provider
                        dark
                      >
                        <div>
                          <v-icon
                            class="pa-2"
                          >
                            mdi-bug-outline
                          </v-icon>
                          <span
                            class="text-h6 white--text"
                          >
                            {{ problemRef(problem) }}
                          </span>
                        </div>
                      </v-theme-provider>
                    </v-sheet>
                  </v-card-title>
                  <v-card-text>
                    <v-simple-table dense>
                      <tbody>
                        <tr
                          v-if="type === 'assyst'"
                        >
                          <td>Affected App</td>
                          <td>{{ problem.affected_app }}</td>
                        </tr>
                        <tr>
                          <td>Fixed</td>
                          <td>
                            <v-icon
                              :color="iconColour(problem.fixed)"
                            >
                              {{ displayIcon(problem.fixed) }}
                            </v-icon>
                          </td>
                        </tr>
                        <tr v-if="problem.fixed === 'y'">
                          <td>Fixed In</td>
                          <td v-if="type === 'assyst'">
                            {{ problem.fixed_in_assyst_software.assyst_version }}
                          </td>
                          <td v-else>
                            {{ problem.fixed_in_ipaas_software.ipaas_version }}
                          </td>
                        </tr>
                        <tr>
                          <td>Workaround Available</td>
                          <td>
                            <v-icon
                              :color="iconColour(problem.workaround_available)"
                            >
                              {{ displayIcon(problem.workaround_available) }}
                            </v-icon>
                          </td>
                        </tr>
                        <tr>
                          <td>Workaround in Script</td>
                          <td>
                            <v-icon
                              :color="iconColour(problem.workaround_in_script)"
                            >
                              {{ displayIcon(problem.workaround_in_script) }}
                            </v-icon>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  export default {
    name: 'SoftwareProblems',
    props: {
      problems: Array,
      type: String,
    },
    data () {
      return {
        
      }
    },
    methods: {
      displayIcon: function (item) {
        if (item === 'y') {
          return 'mdi-check'
        } else {
          return 'mdi-close'
        }
      },
      iconColour: function (item) {
        if (item === 'y') {
          return 'success'
        } else {
          return 'error'
        }
      },
      problemRef: function (item) {
        if (this.type === 'assyst') {
          return item.problem_ref
        } else {
          return item.ipaas_problem_ref
        }
      }
    }
  }
</script>